import { IAppState } from '../../../../common/state';
import { numberToPrettyString } from '@cian/components';
import { plural } from '@cian/utils/lib/shared/plural';
import { getOffersCount } from '../utils/selectors';
import { connect } from 'react-redux';
import { SummaryHeader } from '../../../components/Summary';

export function mapStateToProps(state: IAppState) {
  const offersCount = getOffersCount(state);

  return {
    header: `Найдено ${numberToPrettyString(offersCount)} ${plural(offersCount, [
      'объявление',
      'объявления',
      'объявлений',
    ])}`,
  };
}

export const SummaryHeaderContainer = connect(mapStateToProps)(SummaryHeader);
